var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videoup"},[_vm._v(" 地方地方乱码了是了类似龙胜大浪费了发 ")])}
var staticRenderFns = []

export { render, staticRenderFns }